(function () {
  // EKIPA-ORDER-RULE: karton = 12 limenki. Mora se poklapati sa
  // snippets/ekipa-cart-badge.liquid — Liquid ispiše početno stanje,
  // a ovaj compute ga prepiše čim /cart.js odgovori.
  var STEP = 12;

  function compute(count) {
    if (count === 0) return { target: STEP, state: 'empty' };
    var mod = count % STEP;
    if (mod === 0) return { target: count, state: 'valid' };
    var target = (Math.floor(count / STEP) + 1) * STEP;
    return { target: target, state: 'invalid' };
  }

  function update(count) {
    var r = compute(count);
    document.querySelectorAll('[data-ekipa-cart-badge]').forEach(function (badge) {
      badge.classList.toggle('is-empty', r.state === 'empty');
      badge.classList.toggle('is-valid', r.state === 'valid');
      badge.classList.toggle('is-invalid', r.state === 'invalid');
      var countEl = badge.querySelector('[data-ekipa-cart-count]');
      var targetEl = badge.querySelector('[data-ekipa-cart-target]');
      if (countEl) countEl.textContent = count;
      if (targetEl) targetEl.textContent = r.target;
    });
    document.querySelectorAll('[data-ekipa-sticky-cart]').forEach(function (el) {
      if (count > 0) {
        el.hidden = false;
        el.classList.toggle('is-valid', r.state === 'valid');
        el.classList.toggle('is-invalid', r.state === 'invalid');
        var countEl = el.querySelector('[data-ekipa-sticky-cart-count]');
        if (countEl) countEl.textContent = count;
        var targetEl = el.querySelector('[data-ekipa-sticky-cart-target]');
        if (targetEl) targetEl.textContent = r.target;
      } else {
        el.hidden = true;
        el.classList.remove('is-valid', 'is-invalid');
      }
    });
  }

  window.ekipaUpdateCartBadges = update;

  // ── Cross-tab cart sync ──
  var channel = null;
  try {
    if ('BroadcastChannel' in window) channel = new BroadcastChannel('ekipa-cart');
  } catch (e) {}

  var listeners = [];

  function handleRemoteCart(cart) {
    if (!cart) return;
    update(window.ekipaCanCount ? window.ekipaCanCount(cart) : (cart.item_count || 0));
    listeners.forEach(function (cb) {
      try { cb(cart); } catch (err) {}
    });
  }

  window.ekipaCartSync = {
    broadcast: function (cart) {
      if (!channel || !cart) return;
      try { channel.postMessage({ type: 'cart', cart: cart }); } catch (e) {}
    },
    onRemoteChange: function (cb) {
      if (typeof cb === 'function') listeners.push(cb);
    }
  };

  if (channel) {
    channel.addEventListener('message', function (e) {
      if (!e.data || e.data.type !== 'cart') return;
      handleRemoteCart(e.data.cart);
    });
  }

  var lastVisibilityFetch = 0;
  function refetchIfVisible() {
    if (document.visibilityState !== 'visible') return;
    var now = Date.now();
    if (now - lastVisibilityFetch < 500) return;
    lastVisibilityFetch = now;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(handleRemoteCart)
      .catch(function () {});
  }

  document.addEventListener('visibilitychange', refetchIfVisible);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refetchIfVisible();
  });
  window.addEventListener('focus', refetchIfVisible);

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('[data-ekipa-cart-badge]') && !document.querySelector('[data-ekipa-sticky-cart]')) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { update(window.ekipaCanCount ? window.ekipaCanCount(cart) : cart.item_count); })
      .catch(function () {});
  });
})();
